'use client';

import { useMemo } from 'react';
import GfInteractiveMap from './GfInteractiveMap';
import { distanceKm } from '@/utils/distance';
import { t } from '@/i18n/translations';

const cityTitle = (c) => c?.localizedName || c?.label || c?.name || '';

/**
 * Карта аэропорта: центр-маркер = сам аэропорт, listed-слой = города поблизости
 * (нумерованные + список), meta = расстояние от аэропорта. Порядок городов задаёт
 * страница (сортировка по времени в пути) — нумерация в списке идёт за ним.
 * Тонкий адаптер над GfInteractiveMap.
 */
export default function AirportInteractiveMap({
    airportCoords,
    airportName = '',
    cities = [],
    lang = 'ru',
    countrySlug = '',
    zoom = 10,
}) {
    const ui = t(lang, 'mapsUi').airport;

    const points = useMemo(
        () => (cities || [])
            .filter((c) => c?.coords?.lat && c?.coords?.lng)
            .map((c) => {
                const slug = c.slug?.current || c.slug;
                const km = airportCoords ? distanceKm(airportCoords, c.coords) : null;
                return {
                    id: c._id || slug,
                    title: cityTitle(c),
                    subtitle: c.subtitle || '',
                    coords: c.coords,
                    cover: c.cover,
                    href: slug && countrySlug ? `/${lang}/${countrySlug}/${slug}` : null,
                    meta: km != null ? `${Math.round(km)} ${ui.km}` : null,
                };
            }),
        [cities, airportCoords, lang, countrySlug, ui]
    );

    const layers = useMemo(() => [
        { key: 'city', kind: 'city', listed: true, swatch: 'var(--pine)', label: ui.cities, points },
    ], [points, ui]);

    return (
        <GfInteractiveMap
            layers={layers}
            center={airportCoords?.lat && airportCoords?.lng ? { coords: airportCoords, label: airportName } : null}
            panelEyebrow={ui.panelEyebrow}
            hint={ui.hint}
            ariaLabel={ui.aria(airportName)}
            lang={lang}
            zoom={zoom}
            fitMaxZoom={11}
        />
    );
}
